import useRestQuery, { type UseRestQueryResponse } from "./useRestQuery";
export { UseRestQueryResponse };
export default useRestQuery;
